import { useEffect, useState } from 'react';

const useOmega3ReviewStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch('https://api.reviews.io/product/review?store=weriise.co&sku=OMEGA3');
        const data = await response.json();
        setStats(data?.stats || null);
      } catch (error) {
        setStats(null);
      }
    };

    fetchReviews();
  }, []);

  return stats;
};

export default useOmega3ReviewStats;
